import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "track" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slider", {vertical: _ctx.vertical}]),
    ref: "el",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSliderClicked && _ctx.onSliderClicked(...args)))
  }, [
    _hoisted_1,
    (_ctx.vertical)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.bufferNodeVisible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "buffer",
                style: _normalizeStyle({height:`${_ctx.buffering * 100}%`})
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "filler",
            style: _normalizeStyle({height: `${_ctx.value}%`})
          }, null, 4),
          _createElementVNode("div", {
            class: "thumb",
            ref: "thumb",
            style: _normalizeStyle({top: `${100 - _ctx.value}%`}),
            onPointerdown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args)))
          }, null, 36)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.bufferNodeVisible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "buffer",
                style: _normalizeStyle({width:`${_ctx.buffering * 100}%`})
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "filler",
            style: _normalizeStyle({width: `${_ctx.value}%`})
          }, null, 4),
          _createElementVNode("div", {
            class: "thumb",
            ref: "thumb",
            style: _normalizeStyle({left: `${_ctx.value}%`}),
            onPointerdown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args)))
          }, null, 36)
        ], 64))
  ], 2))
}